
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<StudentIndicator>({})
export default class StudentIndicator extends Vue {
	@Prop({ type: String, required: true }) private studentName!: string;
}
